import { helixActivePanelsKey } from '../../constants';
import * as types from '../../mutationTypes';

export default {
  [types.SET_TOGGLE_APP_USAGE](state, value) {
    state.toggleAppUsage = Boolean(value);
  },

  [types.SET_SHOW_HEADER_CONTAINER](state, value) {
    state.showHeaderContainer = Boolean(value);
  },

  [types.SET_HELIX_ACTIVE_PANELS](state, value) {
    const isValidValue = Array.isArray(value);
    if (!isValidValue) {
      state.helixActivePanels = [];
    } else {
      state.helixActivePanels = value;
      localStorage.setItem(helixActivePanelsKey, JSON.stringify(value)); // Save theme to local storage
    }
  }
};
